import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CompanyService } from '@cp/shared/data-access/company/company.service';

@Component({
  selector: 'cp-book-welcome-call',
  templateUrl: './book-welcome-call.component.html',
  styleUrls: ['./book-welcome-call.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookWelcomeCallComponent {
  public readonly companyAlternativeShortDescriptor =
    this._companyService.getConfigEntry('companyAlternativeShortDescriptor');

  constructor(private _companyService: CompanyService) {}
}
